import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { portalName } from "../../constants/string";

const AuthLayout = ({ helpText, bottomLinks, children, isCombineForm }) => {
  const logoDark = process.env.REACT_APP_LOGO_DARK_URL;
  const logoLight = process.env.REACT_APP_LOGO_LIGHT_URL;

  useEffect(() => {
    if (document.body)
      document.body.classList.add("authentication-bg", "authentication-bg-pattern");

    return () => {
      if (document.body)
        document.body.classList.remove("authentication-bg", "authentication-bg-pattern");
    };
  }, []);

  return (
    <>
      <div className="account-pages mt-5 mb-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={isCombineForm ? 9 : 4}>
              <Card className="bg-pattern">
                <Card.Body className="p-4">
                  <div className="text-center w-75 m-auto">
                    <div className="auth-brand">
                      <Link to="/" className="logo logo-dark text-center">
                        <span className="logo-lg">
                          <img src={logoDark} alt="Logo Dark" height="100" />
                        </span>
                      </Link>

                      <Link to="/" className="logo logo-light text-center">
                        <span className="logo-lg">
                          <img src={logoLight} alt="Logo Light" height="100" />
                        </span>
                      </Link>
                    </div>
                    <p className="text-muted mb-4 mt-3">{helpText}</p>
                  </div>
                  {children}
                </Card.Body>
              </Card>

              {/* bottom links */}
              {bottomLinks}
            </Col>
          </Row>
        </Container>
      </div>

      <footer className="footer footer-alt">
        2023 - {new Date().getFullYear()} &copy; Powered by{" "}
        <Link to="#">{`${portalName}`}</Link>
      </footer>
    </>
  );
};

export default AuthLayout;
